import * as common from './common.json';

export const zh = {
  common,
};
